// OWNER: AREA-EVENTS
// Section layout: supplies the "Event types" breadcrumb for every page under /event-types.
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/event-types')({
  staticData: { crumb: 'Event types' },
  component: Outlet,
})
